/**
 * Campo de preço editável
 */

import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { FormatUtil } from '@utils';

interface CampoPrecoEditavelProps {
  valor: number;
  valorMinimo: number;
  onChange: (novoValor: number) => void;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

export const CampoPrecoEditavel: React.FC<CampoPrecoEditavelProps> = ({
  valor,
  valorMinimo,
  onChange,
  disabled = false,
  size = 'small',
}) => {
  const [valorDisplay, setValorDisplay] = useState(valor.toFixed(2));
  const [erro, setErro] = useState(false);

  useEffect(() => {
    setValorDisplay(valor.toFixed(2));
  }, [valor]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValorDisplay(newValue);
  };

  const handleBlur = () => {
    const numValue = parseFloat(valorDisplay);

    if (isNaN(numValue) || numValue < valorMinimo) {
      setErro(true);
      setValorDisplay(valor.toFixed(2)); // Reverte para valor anterior
    } else {
      setErro(false);
      onChange(numValue);
      setValorDisplay(numValue.toFixed(2));
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();
  };

  return (
    <TextField
      value={valorDisplay}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      disabled={disabled}
      size={size}
      error={erro}
      helperText={erro ? `Mínimo: ${FormatUtil.formatCurrency(valorMinimo)}` : ''}
      InputProps={{
        startAdornment: <InputAdornment position="start">R$</InputAdornment>,
      }}
      sx={{
        width: 120,
        '& .MuiOutlinedInput-root': {
          borderRadius: 2,
          '& input': {
            textAlign: 'right',
            fontWeight: 600,
          },
        },
      }}
    />
  );
};